import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

import Typography from '~/components/core/Atomic/Typography';

const SIZE_TYPES = {
  XL: 'xl',
  LG: 'large',
  SM: 'small',
};

const SIZE_TO_PX = {
  [SIZE_TYPES.XL]: 40,
  [SIZE_TYPES.LG]: 32,
  [SIZE_TYPES.SM]: 24,
};

const useStyles = makeStyles()((_theme, { size }) => ({
  root: {
    fontWeight: 600,
    fontSize: SIZE_TO_PX[size],
  },
}));

const Display = ({ variant = SIZE_TYPES.LG, children }) => {
  const { classes: displayClasses } = useStyles({ size: variant });

  return <Typography className={displayClasses.root}>{children}</Typography>;
};

Display.propTypes = {
  variant: PropTypes.oneOf(Object.values(SIZE_TYPES)),
  children: PropTypes.node.isRequired,
};

Display.TYPES = SIZE_TYPES;

export default Display;
